import dayjs from "dayjs";

export const INBOUND_AGENT_REPORT_MAX_ROWS = 1000;
export const OUTBOUND_REPORT_HISTORY_DAYS = 30;

export const outboundReportStartDate = (
  now: dayjs.ConfigType = dayjs()
): string =>
  dayjs(now).subtract(OUTBOUND_REPORT_HISTORY_DAYS, "day").toISOString();
